import React, {memo, useEffect, useState} from 'react';
import {HInput, HookForm, HTextarea} from '../../../../validation/HForm';
import thingsFormSchema from './thingsFormSchema';
import {useSelector} from "react-redux";
import {handleKeyPressTA} from "../../../../helpers/common";
import {config} from "../../../../helpers/config";

const defaultFormState = {
  things: {
    name: '',
    model: '',
    quantity: 1,
    imei: '',
    sn: '',
    price: 0,
    estimatedValue: '',
    additionalInfo: '',
  },
};

const ThingsForm = memo(({ defaultFormValues, calculationResult = {}, onUpdate, setContextForm, isClear, isCalculationFromAmount, isEstimatedValue, watchEstimate }) => {
  const { accessFeatures } = useSelector(({ user }) => user);
  let form = {};
  const [charCounts, setCharCounts] = useState('');

  useEffect(() => {
    setCharCounts(defaultFormValues.things.additionalInfo)
  }, []);

  useEffect(() => {
    if (defaultFormValues.things) {
      form.setValue('things', defaultFormValues.things);
    } else {
      form.setValue('things', defaultFormState.things);
    }
  }, [defaultFormValues, form]);

  useEffect(() => {
    if (isClear)
      setCharCounts('')
      form.clearErrors()
      form.setValue('additionalInformation', '')
      form.setValue('things.additionalInfo', '')
  }, [isClear])

  const handleChange = () => {
    const data = form.getValues()
    const additionalInfo = data.things.additionalInfo

    setCharCounts(additionalInfo);
    onUpdate({
      ...data,
      additionalInformation: data.additionalInformation,
      additionalInfo: data.things.additionalInfo,
      purities: null,
    });
  };

  return (
    <HookForm
      validationSchema={thingsFormSchema}
      defaultValues={defaultFormState}
      predef={(methods) => {
        (form = methods)
        setContextForm(methods)
      }}
      mode={'onBlur'}>
      <fieldset className="p-b-0">
        <div className="content-section-title">
          <div className="content-section-title-actionitems nostretch">
            <h2>Залоговая ценность</h2>
          </div>
        </div>
      </fieldset>
      <div className="content-datatable">
        <div className="content-datatable-content">
          <table className="table hover">
            <thead>
              <tr>
                <th scope="col">Название</th>
                <th scope="col">Модель</th>
                <th scope="col">IMEI</th>
                <th scope="col">S/N</th>
                <th scope="col">Количество</th>
                <th scope="col" colSpan="2">
                  Оценочная
                  <br />
                  стоимость, руб.
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  <span className="caption">Название</span>
                  <div className="table-cellcontent limitedWidth">
                    <div className="form-element fullwidth">
                      <div className="form-element-data input-m">
                        <HInput
                          h="true"
                          className="input-content"
                          type="text"
                          name="things.name"
                          id="thingsName"
                          onBlur={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </th>
                <td>
                  <span className="caption">Модель</span>
                  <div className="table-cellcontent limitedWidth">
                    <div className="form-element fullwidth">
                      <div className="form-element-data input-m">
                        <HInput
                          h="true"
                          className="input-content"
                          type="text"
                          name="things.model"
                          id="thingsModel"
                          onBlur={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <span className="caption">IMEI</span>
                  <div className="table-cellcontent limitedWidth">
                    <div className="form-element fullwidth">
                      <div className="form-element-data input-m">
                        <HInput
                          h="true"
                          className="input-content text-transform"
                          type="text"
                          name="things.imei"
                          id="thingsIMEI"
                          onBlur={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <span className="caption">S/N</span>
                  <div className="table-cellcontent limitedWidth">
                    <div className="form-element fullwidth">
                      <div className="form-element-data input-m">
                        <HInput
                          h="true"
                          className="input-content text-transform"
                          type="text"
                          name="things.sn"
                          id="thingsSn"
                          onBlur={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <span className="caption">Количество</span>
                  <div className="table-cellcontent">
                    <div className="form-element">
                      <div className="form-element-data number">
                        <HInput
                          h="true"
                          className="input__disabled"
                          type="number"
                          name="things.quantity"
                          id="thingsQuantity"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <span className="caption">
                    Оценочная
                    <br />
                    стоимость, руб.
                  </span>
                  <div className="table-cellcontent">
                    <div className="form-element">
                      <div className="form-element-data number">
                        <HInput
                            h="true"
                            className="input"
                            type="text"
                            name="things.estimatedValue"
                            id="thingsCost"
                            decimals={2}
                            onBlur={(e) => {
                              watchEstimate(e.target.value)
                              handleChange()
                              isCalculationFromAmount(false)
                              defaultFormValues.date && isEstimatedValue(true)
                            }}
                        />

                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              { accessFeatures['things.additional_info'] &&
                <tr>
                  <td colSpan={12}>
                    <div className="form-element-data">
                      <label className="form-element-label m-r-spacer" htmlFor="showComment">
                        Доп. описание
                      </label>
                      <HTextarea
                          h="true"
                          className="input full-width purities-additionalInformation"
                          rows="1"
                          cols="10"
                          name="things.additionalInfo"
                          onChange={accessFeatures['count_additionalInfo_symbols']
                              ? ()=>handleChange()
                              : null
                          }
                          onKeyDown={config().validatePurities ?
                              (e) => handleKeyPressTA(e) : null}
                      />
                      {
                        accessFeatures['count_additionalInfo_symbols'] &&
                          <span>{charCounts.length} /38</span>
                      }
                    </div>
                  </td>
                </tr>
              }
              {
                accessFeatures['deal.additional_info'] &&
                  <tr>
                    <td colSpan={6}>
                      <div className="form-element-data">
                        <label className="form-element-label m-r-spacer" htmlFor="showComment">
                          Добавить комментарий
                        </label>
                        <HTextarea
                            h="true"
                            className="input full-width purities-additionalInformation"
                            rows="1"
                            cols="10"
                            name="additionalInformation"
                            defaultValue={defaultFormValues.additionalInformation}
                            onBlur={handleChange}
                        />
                      </div>
                    </td>
                  </tr>
              }
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="4">
                  <p>Итого</p>
                </td>
                <td colSpan="1">
                  <span className="caption">Количество</span>
                  <p>{calculationResult.totalQuantity}</p>
                </td>
                <td colSpan="2">
                  <span className="caption">
                    Оценочная
                    <br />
                    стоимость, руб.
                  </span>
                  <p>{calculationResult.totalEstimatedValue.toFixed(2)}</p>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </HookForm>
  );
});

export default ThingsForm;
